import { EBasicOverlays } from 'Components/shared/Overlay/elements/BasicOverlayManager/types';
import { EOverlayContentWidth, POSITIONS } from 'Components/shared/Overlay/elements/OverlayFixedBg/types';
import { basicChannel } from 'src/channels/basic.channel';

/**mobile bottom and desktop center */
export const BrandOverlayBottom = (type: EBasicOverlays, contentData: any) => {
  basicChannel.send({
    action: 'display',
    data: {
      content: {
        type: type,
        withoutPadding: false,
        bottom: true,
        width480: true,
        noRoundedCorners: true,
        ...contentData,
      },
      onClose: () => {
        if (typeof contentData?.onClose === 'function') {
          contentData?.onClose?.();
        }
      },
      position: POSITIONS.CENTER,
      contentWidth: EOverlayContentWidth.AUTO,
    },
  });
};

/**mobile center, desktop center */
export const BrandOverlayCenter = (type: EBasicOverlays, contentData: any) => {
  basicChannel.send({
    action: 'display',
    data: {
      content: {
        type: type,
        width480: true,
        mobileSidesPaddigns: true,
        ...contentData,
      },
      onClose: () => {
        if (typeof contentData?.onClose === 'function') {
          contentData?.onClose?.();
        }
      },
      position: POSITIONS.CENTER,
      contentWidth: EOverlayContentWidth.MOB_CENTER_DESKTOP_CENTER,
    },
  });
};

// mobile fullscreen, desktop center
// todo...
